
class EmploymentRelationship {
  constructor (data = {}) {
    this.employeeNumber = data.employeeNumber;
    this.fromDate = data.fromIsoDate;
    this.legalPersonId = data.legalPersonId;
    this.naturalPersonId = data.naturalPersonId;
    this.untilDate = data.untilIsoDate;
    this.absenceOnFromDate = null;

    if (data.employmentRelationShipDetails) {
      this.employmentRelationshipDetails =
        data.employmentRelationShipDetails
          .map(e => new EmploymentRelationshipDetail(e))
          .sort((a, b) => new Date(a.fromDate) > new Date(b.fromDate) ? -1 : 1);

      /* let result = [];
      data.employmentRelationShipDetails.forEach(e => {
        result.push(new EmploymentRelationshipDetail(e));
        result.push(new EmploymentRelationshipDetail(e));
        result.push(new EmploymentRelationshipDetail(e));
        result.push(new EmploymentRelationshipDetail(e));
      });
      this.employmentRelationshipDetails = result; */
    } else this.employmentRelationshipDetails = [];
  }
}

class EmploymentRelationshipDetail {
  constructor (data = {}) {
    this.fromDate = data.fromIsoDate;
    this.grossAnnualSalary = data.grossAnnualSalary;
    this.natureOfEmployment = data.natureOfEmployment;
    this.noRisk = data.noRisk;
    this.professionClassification = data.professionClassification;
    this.svSalary = data.svSalary;
    this.untilDate = data.untilIsoDate;
  }
}

const ProfessionClassification = {
  Undefined: 'Undefined',
  Administrative: 'Administrative',
  Commercial: 'Commercial',
  Traveling: 'Traveling',
  ManualLabor: 'ManualLabor',
  HeavyLabor: 'HeavyLabor'
};

const NatureOfEmployment = {
  Undefined: 'Undefined',
  Permanent: 'Permanent',
  Dga: 'Dga',
  OnCallWithAppearanceObligation: 'OnCallWithAppearanceObligation',
  OnCallWithoutAppearanceObligation: 'OnCallWithoutAppearanceObligation',
  Trainee: 'Trainee',
  TemporaryAgencyWorker: 'TemporaryAgencyWorker',
  ReturningWao: 'ReturningWao',
  WiwArt4: 'WiwArt4',
  Temporary: 'Temporary',
  OnCall: 'OnCall'
};

export {
  EmploymentRelationship,
  EmploymentRelationshipDetail,
  ProfessionClassification,
  NatureOfEmployment
};
